import { render, staticRenderFns } from "./PerfPerCategory.vue?vue&type=template&id=e5df9a2e&scoped=true&"
import script from "./PerfPerCategory.vue?vue&type=script&lang=js&"
export * from "./PerfPerCategory.vue?vue&type=script&lang=js&"
import style0 from "./PerfPerCategory.vue?vue&type=style&index=0&id=e5df9a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5df9a2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
